

// 
var swiper = new Swiper(".mobileSlider", {
  slidesPerView: 1.2,
  spaceBetween: 16,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    440: {
      slidesPerView: 1.3,
    },
    
    540: {
      slidesPerView: 2.3,
    },
    768: {
      slidesPerView: 3.2,
    },
  },
});

//

//

var swiper = new Swiper(".mobileSlider1", {
  slidesPerView: 1,
  spaceBetween: 16,
  breakpoints: {
    440: {
      slidesPerView: 1,
    },
    
    540: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
  },
});

// 
var swiper = new Swiper(".productSlider", {
  slidesPerView: 1,
  spaceBetween: 16,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    440: {
      slidesPerView: 1,
    },
    
    540: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 1,
    },
  },
});

// 
var swiper = new Swiper(".cateSlider1", {
  slidesPerView: 1.3,
  spaceBetween: 16,
  navigation: {
    nextEl: ".swiper-button-next1",
    prevEl: ".swiper-button-prev1",
  },
  breakpoints: {
    440: {
      slidesPerView: 1.3,
    },
    
    540: {
      slidesPerView: 2.3,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 32,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 32,
    },
  },
});

// 
var swiper = new Swiper(".cateSlider", {
  slidesPerView: 1.3,
  spaceBetween: 16,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    440: {
      slidesPerView: 1.3,
    },
    
    540: {
      slidesPerView: 2.3,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 32,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 32,
    },
  },
});



let burger = document.getElementById('navTrigger'),
    nav    = document.getElementById('navMenu');

burger.addEventListener('click', function(e){
  this.classList.toggle('active');
  nav.classList.toggle('active');
});